import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as ArrowRightLong } from "assets/icons/arrow-right-long.svg";

const RecommendButton = ({
  className = "",
  disabled,
  backLoading = false,
  isFinalQuestion = false,
  isShowBackBtn = false,
  nextLoading = false,
  onBack,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex items-center gap-6 p-5 fixed bottom-0 w-full max-w-2xl z-[99]  ${className}`}
    >
      {isShowBackBtn && (
        <Button
          className="w-2/12 flex gap-1  items-center justify-center p-0 border-none min-h-0 h-0 text-gray-4 text-sm hover:!text-gray-4 font-medium font-dana"
          disabled={disabled}
          loading={backLoading}
          onClick={onBack}
        >
          <ArrowRightLong
            className={`w-4 h-4 ${disabled ? "[&>path]:fill-gray--2" : ""}`}
          />
          {t("pma-onboarding.before")}
        </Button>
      )}

      <Button
        disabled={disabled}
        loading={nextLoading}
        className={`${
          disabled ? "disabled-button-large" : "primary-button-large"
        } justify-center items-center  ${isShowBackBtn ? "w-10/12" : "w-full"}`}
        htmlType="submit"
      >
        {isFinalQuestion ? t("submit") : t("pma-onboarding.next-question")}
      </Button>
    </div>
  );
};

export default RecommendButton;
